/*
*  API calls as the logged in customer (Derma 2.0® products, the checkout, the account). The token is refreshed
*  automatically when it has expired. Kept apart from apiHandlers.js, which manages the admin's login.
*/

import { loadCustomerTokens, storeCustomerTokens, clearCustomerTokens } from "../logic/localStorage";

//Set at start up: called when the login can't be refreshed any more (the customer is logged out)
let onLoggedOut = () => {/* Nothing yet */};
export const setCustomerLoggedOutHandler = (handler) => {
  onLoggedOut = handler;
};

const send = (url, method, data, token) => {
  const headers = {};
  if (data !== undefined) {
    headers["Content-Type"] = "application/json";
  }
  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }
  return fetch(`/api${url}`, {
    method,
    headers,
    body: (data !== undefined) ? JSON.stringify(data) : undefined,
  });
};

//Swaps an expired token for a new one, or logs the customer out
const refresh = async (token, refreshToken) => {
  const response = await send("/Customer/Refresh", "POST", { token, refreshToken });
  if (response.ok) {
    const tokens = await response.json();
    storeCustomerTokens(tokens.token, tokens.refreshToken);
    return tokens.token;
  }
  clearCustomerTokens();
  onLoggedOut();
  return null;
};

/* Calls the API with the customer's token (if logged in). Resolves with the JSON response, or rejects with the server's
*  error ({ errorText } / { errors }) or {} when it couldn't be reached.
*  An expired token on a public endpoint (e.g. /Products) doesn't fail the call - the server just treats it as a visitor
*  and says so in the Token-Expired header - so check for that on every response.
*/
export const customerRequest = async (url, method="GET", data=undefined) => {
  const { token, refreshToken } = loadCustomerTokens();
  let response;
  try {
    response = await send(url, method, data, token);
    if (token && response.headers.has("Token-Expired")) {
      const newToken = await refresh(token, refreshToken);
      response = await send(url, method, data, newToken);
    }
  }
  catch (e) {
    throw {};
  }

  const json = await response.json().catch(() => null);
  if (!response.ok) {
    throw json || {};
  }
  return json;
};
